// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: false,
		collapseOnPCByDefault: true
		// paginationType: boostPFSConfig.custom.pagination_type.indexOf("load_more") != -1 ? "load_more" :
		// 				(boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' : 'default'),
	},
	selector: {
		trackingQuickView: '.quick_shop'
	}
};
// Declare Templates
var boostPFSTemplate = {
	// Grid Template
	'productGridItemHtml': '<div class="{{itemDesktopWidthClass}} product_grid_item medium-down--one-half {{itemMobileWidthClass}} column {{itemQuickShopClass}} {{itemSwapImageClass}} {{itemHoverImage}} {{itemStickersClass}}' +
	' thumbnail product__thumbnail product__grid-item' +
	' thumbnail__hover-overlay--{{itemHoverClass}}' +
	' has-padding-bottom" data-product-id="{{prodId}}">' +
	'<div class="product-wrap">' +
	'<div class="product-image__wrapper">' +
	'{{quickAddBtn}}' +
	'<div class="image__container product__imageContainer">' +
	'<a class="on-ga-click" onclick="track_click(event);" href="{{itemUrl}}" data-product-id="{{prodId}}">' +
	'{{itemStickers}}' +
    '{{familyMatchingBadge}}' +
	'{{itemImages}}' +
	'{{itemHover}}' +
	'</a>' +
	'</div>' +
	'</div>' +
	'<div class="thumbnail__caption text-align-{{itemTextAlignClass}}">' +
	'{{itemProductInfo}}' +
	'</div>' +
	'</div>' +
	'{{itemSwatch}}' +
	'{{itemReviews}}' +
	'</div>',

	'itemHoverHtml' : '<div class="thumbnail-overlay__container">' +
	'<a class="hidden-product-link" href="{{itemUrl}}">{{itemTitle}}</a>' +
	'{{itemProductInfoHover}}' +
	'{{itemQuickShop}}' +
	'{{itemReviewsHover}}' +
	'</div>',

	'itemProductInfoHtml': '<h2 class="product-thumbnail">' +
	'{{itemVendor}}' +
	'<a href="{{itemUrl}}" class="product-thumbnail__title">{{itemTitle}}</a>' +
	'{{itemComingSoon}}' +
	'{{itemPrice}}' +
	'{{itemLabels}}'+
	'</h2>',

	// Pagination Template
	'previousActiveHtml': '<a href="{{itemUrl}}" class="pagination-previous">'+ boostPFSConfig.label.previous +'</a>',
	'nextActiveHtml': '<a href="{{itemUrl}}" class="pagination-next">'+ boostPFSConfig.label.next +'</a>',
	'pageItemHtml': '<li><a class="pagination-link" href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li><a class="pagination-link is-current">{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li><a class="pagination-ellipsis">…</a></li>',
	'paginateHtml': '<nav class="pagination paginate--both" role="navigation" aria-label="pagination">{{previous}}<ul class="pagination-list">{{pageItems}}</ul>{{next}}</nav>',

	// Sorting Template
	'sortingHtml': '<select aria-label="Sort by" class="sort_by">{{sortingItems}}</select>',
};
function buildFamilyMatchingBadge(data) {
    if (data.tags && data.tags.indexOf('fammatching') !== -1) {
        return '<div class="family-matching-badge">Family Matching</div>';
    }
    return '';
}
(function () {
	BoostPFS.inject(this);

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index, totalProduct) {
		  if (!data) data = this.data;
  if (!index) index = this.index;
  if (!totalProduct) totalProduct = this.totalProduct;

  function buildImageElement(image) {
    if (!image || !image.src) {
      return '';
    }
    return '<img src="' + image.src + '" alt="' + (image.alt || '') + '" class="lazyload">';
  }

  if(data.data_type === 'banner') {
    var itemHtml = boostPFSThemeConfig.banner_templates;
    
    var desktop_image = data.desktop_image ? buildImageElement(data.desktop_image) : '';
    var mobile_image = data.mobile_image ? buildImageElement(data.mobile_image) : '';
    var category = data.category || '';

    // Replace the placeholders
    itemHtml = itemHtml.replace(/\{\{category\}\}/g, category);
    itemHtml = itemHtml.replace(/\{\{desktop_image\}\}/g, desktop_image);
    itemHtml = itemHtml.replace(/\{\{mobile_image\}\}/g, mobile_image);
   
    var tempElement = document.createElement('div');
    tempElement.innerHTML = itemHtml;
   
    if (desktop_image || mobile_image) {
      tempElement.querySelector('.image-container').style.display = 'block';
      tempElement.querySelector('.category-container').style.display = 'none';
    } else {
      tempElement.querySelector('.image-container').style.display = 'none';
      tempElement.querySelector('.category-container').style.display = 'block';
    }
    return tempElement.innerHTML;
  } else if(data.data_type === 'header') {
    var itemHtml = boostPFSThemeConfig.division_title;
    
    //Insert title
    itemHtml = itemHtml.replace(/\{\{title\}\}/g, data.title);
    
    return itemHtml;
  } else if(data.data_type === 'grid_banner') {
    var itemHtml = boostPFSThemeConfig.templates.grid_banner_tpl;
    
    var image = buildImageElement(data.image)
    
    //Insert the image
    itemHtml = itemHtml.replace(/\{\{image\}\}/g, image);
    
    itemHtml = itemHtml.replace(/\{\{url\}\}/g, data.url);
    
    return itemHtml;
  }
		else {
	
		  // Get Template
		  var itemHtml = boostPFSTemplate.productGridItemHtml;
		  // Add class
		  var itemDesktopWidthClass = 'one-third';
		  switch (boostPFSConfig.custom.products_per_row){
			case 1: itemDesktopWidthClass = 'one-whole'; break;
			case 2: itemDesktopWidthClass = 'one-half'; break;
			case 3: itemDesktopWidthClass = 'one-third'; break;
			case 4: itemDesktopWidthClass = 'one-fourth'; break;
			case 5: itemDesktopWidthClass = 'one-fifth'; break;
			case 6: itemDesktopWidthClass = 'one-sixth'; break;
			case 7: itemDesktopWidthClass = 'one-seventh'; break;
			case 8: itemDesktopWidthClass = 'one-eighth'; break;
		  }
		  itemHtml = itemHtml.replace(/{{itemDesktopWidthClass}}/g, itemDesktopWidthClass);
		  itemHtml = itemHtml.replace(/{{itemMobileWidthClass}}/g, boostPFSConfig.custom.mobile_products_per_row == 1 ? 'small-down--one-whole' : 'small-down--one-half');
		  itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, boostPFSConfig.custom.enable_quickshop ? 'quick-shop--true quick-shop--closed product-{{itemId}} js-product_section' : '');
		  itemHtml = itemHtml.replace(/{{itemStickersClass}}/g, boostPFSConfig.custom.stickers_enabled ? 'has-thumbnail-sticker' : '');
		  itemHtml = itemHtml.replace(/{{itemHoverClass}}/g, boostPFSConfig.custom.thumbnail_hover_enabled.toString());
		  itemHtml = itemHtml.replace(/{{itemSwapImageClass}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'swap--true' : '');
		  itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, boostPFSConfig.custom.show_secondary_image && data.images_info.length > 1 ? 'has-secondary-image-swap' : '');
		  itemHtml = itemHtml.replace(/{{itemTextAlignClass}}/g, boostPFSConfig.custom.thumbnail_text_alignment);
          itemHtml = itemHtml.replace(/{{prodId}}/g, data.id);

          // Comment by MJ: For custom color variant seperation
		 //  var colors = data.options_with_values.find(function(item){
			// if(item.name === 'color'){
			//   return item;
			// }
		 //  });
		 //  if(typeof colors === "object" && colors.values.length > 1){
			// return colors.values.map(function(color){
			//   var variant = isColorAvailable(data,color.title);
			//   if(variant.length > 0){
			// 	var i = colors.values.map(e => e.title).indexOf(color.title);
			// 	var imgIndex = color.image ? color.image - 1 : i;
			// 	return populateCard(itemHtml, data, variant, imgIndex);
			//   }
			// }).join("")
		 //  }else{
			// return populateCard(itemHtml, data);
		 //  }
          return populateCard(itemHtml, data);
		}
	  };


    // function trackProductClick(productObj) {
    //   dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    //   dataLayer.push({
    //     'event': 'productClick',
    //     'ecommerce': {
    //       'click': {
    //         'actionField': {'list': 'Search Results'},      // Optional list property.
    //         'products': [{
    //           'name': productObj.name,                      // Name or ID is required.
    //           'id': productObj.id,
    //           'price': productObj.price,
    //           'brand': productObj.brand,
    //           'category': productObj.cat,
    //           'variant': productObj.variant,
    //           'position': productObj.position
    //          }]
    //        }
    //      },
    //      'eventCallback': function() {
    //        document.location = productObj.url
    //      }
    //   });
    // }
	
	function isColorAvailable(data, color ){
		return data.variants.filter(function(v){
			return (v.title).toLowerCase().includes(color.toLowerCase()) && v.available;
		})
	}

	function populateCard(itemHtml, data, variant, imageIndex){
		var show_quick_add = boostPFSThemeConfig.custom.show_quick_add;
		// Quick add
		if(show_quick_add) {
			var selectedColorVariant = {
				options: data.options_with_values
			}
			var color_index = data.options_with_values.findIndex(option => option.name ==="color");
			if(variant) {
				var op_array = variant[0].title.split(' / ');
				var f_c = op_array[color_index];
				selectedColorVariant.current_color = {
					value: f_c,
					index: color_index,
					option: 'Color'
				}
			}else {
				var f_c = data.options_with_values.find(option => option.name === 'color').values[0].title;
				selectedColorVariant.current_color = {
					value: f_c,
					index: color_index,
					option: 'Color'
				}
			}

			selectedColorVariant.variants = data.variants;
			selectedColorVariant.id = data.id;
			selectedColorVariant.product_handle = data.handle;
			selectedColorVariant.product = data;
			var btn_html = boostPFSThemeConfig.templates.quick_add_btn_tpl;

		btn_html = btn_html.replace(/{{data}}/g, JSON.stringify(selectedColorVariant))
		itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, btn_html);
        }else {
		itemHtml = itemHtml.replace(/{{quickAddBtn}}/g, '');
        }
		// Add stickers
		var itemStickers = buildStickers(data);
		itemHtml = itemHtml.replace(/{{itemStickers}}/g, itemStickers);
	
        // Add family matching tag
        var familyMatchingBadge = buildFamilyMatchingBadge(data);
        itemHtml = itemHtml.replace(/{{familyMatchingBadge}}/g, familyMatchingBadge);
    

		// Add images
		var itemImages = buildImages(data,imageIndex,variant);
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImages);

		// Add hover elements
		var itemHover = buildHover(data);
		itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHover);

		// Add product info
		itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, boostPFSTemplate.itemProductInfoHtml);

		// Add vendor
		var itemVendor = boostPFSConfig.custom.display_vendor ? '<span class="product-thumbnail__vendor">{{itemVendor}}</span>' : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendor);

		var collectionHandles = data.collections.map(x => x.handle);
		var isComingSoon = collectionHandles.indexOf('coming-soon') != -1;
		// Add coming soon
		if (isComingSoon){
			itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '<span>' + boostPFSConfig.label.coming_soon + '</span>');
			itemHtml = itemHtml.replace(/{{itemPrice}}/g, '');
			itemHtml = itemHtml.replace(/{{itemLabels}}/g, '');
			// Add price
		} else {
			itemHtml = itemHtml.replace(/{{itemComingSoon}}/g, '');
			itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data, variant));
			itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		}

		// Add swatch
		var itemSwatch = buildSwatch(data);
		itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatch);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			var itemReviews = boostPFSConfig.custom.enable_shopify_collection_badges && boostPFSConfig.custom.enable_shopify_review_comments ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' : '';
			if (boostPFSConfig.custom.thumbnail_hover_enabled) {
				itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, itemReviews);
				itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
			} else {
				itemHtml = itemHtml.replace(/{{itemReviewsHover}}/g, '');
				itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviews);
			}
		}

		// Add quick shop button placeholder
		var itemQuickShop = boostPFSConfig.custom.enable_quickshop ? '<div data-boost-pfs-quickshop-id="{{itemId}}" style="display: none"></div>' : '';
		itemHtml = itemHtml.replace(/{{itemQuickShop}}/g, itemQuickShop);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
		if (variant) {
			itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant[0].id);
		}else{
			itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		}
		return itemHtml;
	}

	function buildStickers(data){
		var html = '';
		var stickers = [];
		if (boostPFSConfig.custom.stickers_enabled){
			var collections = data.collections.map(x => x.handle);
			var stickerCollections = ['best-seller', 'coming-soon', 'new', 'pre-order', 'staff-pick'];
			for (var i = 0; i < stickerCollections.length; i++){
				var stickerCollection = stickerCollections[i];
				if (collections.indexOf(stickerCollection) != -1){
					var stickerText = boostPFSConfig.label[stickerCollection.replace('-', '_')];
					var sticker = '<div class="'+ stickerCollection +'-sticker thumbnail-sticker sticker-'+ i +'"><span class="sticker-text">' + stickerText + '</span></div>';
					stickers.push(sticker);
				}
			}

			var onSale = data.available && data.price_min < data.compare_at_price_max;
			if (onSale){
				var sticker = '<div class="sale-sticker thumbnail-sticker"><span class="sticker-text">' + boostPFSConfig.label.sale + '</span></div>';
				stickers.push(sticker);
			}

			if (stickers.length > 0){
				html = 	'<div class="sticker-holder sticker-shape-'+ boostPFSConfig.custom.sticker_shape +' sticker-position-'+ boostPFSConfig.custom.sticker_position +'">' +
				'<div class="sticker-holder__content sticker-holder__content--">' +
				stickers.join('') +
				'</div>'+
				'</div>';
			}
		}
		return html;
	}

	function buildImages(data,imageIndex){
		var html = '';
		var images = data.images_info;
		if (!images || images.length == 0){
			images.push({
				src: boostPFSAppConfig.general.no_image_url,
				width: 480,
				height: 480
			})
		}

		html += buildImageElement(images[imageIndex || 0]);

		var images_by_color = data.images_info.filter(img => img.alt === images[imageIndex || 0].alt && img.src !== images[imageIndex || 0].src);

		if (boostPFSConfig.custom.show_secondary_image && images.length > 1 && boostPFSConfig.custom.thumbnail_hover_enabled){
			html += buildImageElement(images_by_color.length > 0 ? images_by_color[0] : images[imageIndex || 0], 'lazypreload secondary swap--visible');
		}

		return html;
	}

	function buildImageElement(image, additionalClass) {
		if(typeof image === 'undefined' || image === null) {
			return '';
		}
		var additionalClass = (typeof additionalClass !== 'undefined') ? additionalClass : '';
		var html = '';
		var heightStyle = '';
		var widthStyle = '';
		var aspectRatio = image.width / image.height;
		if (boostPFSConfig.custom.align_height){
			heightStyle += 'max-height: ' + boostPFSConfig.custom.collection_height + 'px;';
			widthStyle += 'width: calc(' + image.width + ' / ' + image.height + ' * ' + boostPFSConfig.custom.collection_height + 'px)';
			// widthStyle += 'width: '+ (aspectRatio * boostPFSConfig.custom.collection_height) +'px; max-width: '+ image.width +'px;';
		}

		var backgroundColor = boostPFSConfig.custom.image_loading_style == 'color' ? 'background: url('+ Utils.optimizeImage(image.src, '1x') +'); ' : '';
		var lowQualityImage = boostPFSConfig.custom.image_loading_style == 'blur-up' ? Utils.optimizeImage(image.src, '50x') : '';

		html += '<div class="image-element__wrap" style="' + backgroundColor + heightStyle + widthStyle + '">' +
		'<img alt="{{itemTitle}}"'+
		' class="lazyload transition--'+ boostPFSConfig.custom.image_loading_style + ' ' + additionalClass + '"'+
		(lowQualityImage && lowQualityImage !== '' ?
		' src="' + lowQualityImage + '"' : '' ) +
		' data-src="'+ Utils.optimizeImage(image.src, '1600x') +'"'+
		' data-sizes="auto"'+
		' data-aspectratio="' + aspectRatio +'"'+
		' data-srcset="' + bgset(image) +'"'+
		' srcset="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
		' height="'+ image.height +'"'+
		' width="'+ image.width +'"'+
		' style="'+ heightStyle +'"'+
		'/>' +
		'</div>';
		return html;
	}

	function buildHover(data){
		// return '';
		var html = '';
		if (boostPFSConfig.custom.enable_quickshop || boostPFSConfig.custom.thumbnail_hover_enabled){
			html = boostPFSTemplate.itemHoverHtml;
			if (boostPFSConfig.custom.thumbnail_hover_enabled){
				var itemProductInfoHover = 	'<div class="quick-shop__info">'+
				'<div class="thumbnail-overlay">'+
				'<div class="info text-align-center">'+
				'{{itemProductInfo}}' +
				'</div>'+
				'</div>' +
				'</div>';
				html = html.replace(/{{itemProductInfoHover}}/g, itemProductInfoHover);
			} else {
				html = html.replace(/{{itemProductInfoHover}}/g, '');
				html = html.replace(/{{itemReviews}}/g, '');
			}
			if (!boostPFSConfig.custom.enable_quickshop){
				html = html.replace(/{{itemQuickShop}}/g, '');
			}
		}
		return html;
	}

	function buildPrice(data, variants){
		var html = '';
		if(data.available){
			if(variants && variants.length > 0){
				var variant = variants[0];
				var onSale = parseInt(variant.compare_at_price) > parseInt(variant.price);
				var price = parseInt(variant.price);
				var compare_at_price = parseInt(variant.compare_at_price);
			}else{
				var onSale = parseInt(data.compare_at_price_max) > parseInt(data.price_min);
				var price = parseInt(data.price_min);
				var compare_at_price = parseInt(data.compare_at_price_max);
			}
			html += '<span class="product-thumbnail__price price '+ (onSale ? 'sale' : '') +'"> ';
			if (price > 0){
				html += '<span class="money">' + Utils.formatMoney(price) + '</span> ';
			} else {
				html += boostPFSConfig.custom.free_price_text;
			}
			if (onSale){
				html += '<span class="product-thumbnail__was-price was-price">' +
				'<span class="money">' + Utils.formatMoney(compare_at_price) + '</span>' +
				'</span>';
			}
			html += '</span>';
		}else{
			html += '<span class="product-thumbnail__price price">';
			html += '<span class="product-thumbnail__sold-out sold-out">' + boostPFSConfig.label.sold_out + '</span>'
			html += '</span>';
		}
		return html;




		var onSale = data.compare_at_price_max > data.price_min;
		var soldOut = !data.available;
		var priceVaries = data.price_max != data.price_min;
		html += '<span class="product-thumbnail__price price '+ (onSale ? 'sale' : '') +'"> ';
		if (!soldOut){
			if (data.price_min > 0){
				html += '<span class="money">';
				if (priceVaries){
					//html += '<small><em>' + boostPFSConfig.label.from + '</em></small> ';
				}
				html +=  Utils.formatMoney(data.price_min) + '</span> ';
			} else {
				html += boostPFSConfig.custom.free_price_text;
			}
			if (onSale){
				html += '<span class="product-thumbnail__was-price was-price">' +
				'<span class="money">' + Utils.formatMoney(data.compare_at_price_max) + '</span>' +
				'</span>';
			}
		} else {
			html += '<span class="product-thumbnail__sold-out sold-out">' + boostPFSConfig.label.sold_out + '</span>'
		}
		html += '</span>';

		return html;
	}

	function buildLabels(data){
		var len = data.tags.length,
		labels = '';
		for(var i=0; i < len; i++){
			if(data.tags[i].trim().search(/^[Ll]abel \d+: /) != -1){
				labels += '<span>' +  data.tags[i].replace(/^[Ll]abel \d+: /, "") + "</span>";
			}
			if(i+1 === len){
				if(labels !== ""){
					return '<span class="product-thumbnail__labels">' + labels + '</span>';
				}else{
					return "";
				}
			}
		}
	}

	function buildSwatch(data){
		var html = '';
		var values = [];
		var swatchItems = [];
		if (boostPFSConfig.custom.collection_swatches){
			data.variants.forEach(function(variant){
				var colorValue = '';
				var optionValue = '';
				variant.merged_options.forEach(function(option){
					var key = option.split(':')[0];
					var value = option.split(':')[1];
					if ((key.toLowerCase().indexOf('color') != -1 || key.toLowerCase().indexOf('colour') != -1) && values.indexOf(value.toLowerCase()) == -1){
						values.push(value.toLowerCase());
						colorValue = value;
						optionValue = key;
					}
				});
				if (colorValue){
					var swatchItem ='<a href="{{variantUrl}}" class="swatch swatch__style--{{swatchShape}}" data-swatch-name="meta-{{slugifyOptionValue}}_{{slugifyColorValue}}">' +
					'<span data-image="{{variantImage}}" style="background-color: {{colorBackground}}; background-image: url({{variantImage}});">' +
					'<img class="swatch__image" src="{{colorImage}}" onerror="this.className += \' swatch__image--empty\'">' +
					'</span>' +
					'</a>';

					swatchItem = swatchItem.replace(/{{swatchShape}}/g, boostPFSConfig.custom.collection_swatches_shape);
					swatchItem = swatchItem.replace(/{{colorBackground}}/g, Utils.slugify(colorValue).split('-').pop());
					swatchItem = swatchItem.replace(/{{slugifyOptionValue}}/g, Utils.slugify(optionValue).replace('-', '_'));
					swatchItem = swatchItem.replace(/{{slugifyColorValue}}/g, Utils.slugify(colorValue).replace('-', '_'));
					swatchItem = swatchItem.replace(/{{variantUrl}}/g, Utils.buildProductItemUrl(data) + '?variant=' + variant.id);

					var colorImage = boostPFSAppConfig.general.file_url.split('?')[0] + Utils.slugify(colorValue) + '_50x.png';
					swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);

					var variantImage = '';
					var noImageClass = '';
					if (variant.image){
						switch (boostPFSConfig.custom.products_per_row){
							case 2: variantImage = Utils.optimizeImage(variant.image, '600x'); break;
							case 3: variantImage = Utils.optimizeImage(variant.image, '500x'); break;
							default: variantImage = Utils.optimizeImage(variant.image, '400x'); break;
						}
					}
					swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
					swatchItems.push(swatchItem);
				}
			})
		}
		if (swatchItems.length > 0){
			html = '<div class="thumbnail-swatch is-justify-'+ boostPFSConfig.custom.thumbnail_text_alignment +' is-flex-wrap">' +
			swatchItems.join(' ') +
			'</div>';
		}
		return html;
	}

	function bgset(image){
		var bgset = '';
		if (image) {
			var aspect_ratio = image.width / image.height;

			if (image.width > 180) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
			if (image.width > 360) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
			if (image.width > 540) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
			if (image.width > 720) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
			if (image.width > 900) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
			if (image.width > 1080) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
			if (image.width > 1296) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
			if (image.width > 1512) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
			if (image.width > 1728) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
			if (image.width > 1950) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
			if (image.width > 2100) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
			if (image.width > 2260) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
			if (image.width > 2450) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
			if (image.width > 2700) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
			if (image.width > 3000) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
			if (image.width > 3350) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
			if (image.width > 3750) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
			if (image.width > 4100) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
			bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
		}
		return bgset;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct

		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);


		var product_item_grid = $('.product_grid_item');

        var productsCount =
          Globals.queryParams.page <= 1
      ? product_item_grid.length
      : (Globals.queryParams.page - 1) * Globals.queryParams.limit +
          product_item_grid.length;

        var paginationTotal = $(".boost-pfs-filter-load-more-count");

        paginationTotal.html(
          `Showing ${productsCount} out of ${totalProduct} ${totalProduct > 1 ? 'Products' : 'Product'}`
        );


		var product_count_per_page = this.data.event_type === 'filter' ? this.data.total_product : this.data.products.length;


		$('.boost-pfs-filter-custom-total').removeClass('total-is-loading');


		$(".boost-pfs-filter-custom-total").html(
		  `${product_count_per_page} Items`
		);


		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
		ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
          	var currentSortValue = window.Globals.queryParams.sort || '';
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
//               	sortingItemsHtml += '<option value disabled selected hidden>SORT BY</option>';
				for (var k in sortingArr) {
                  sortingItemsHtml += `<option value="${k}" ${k == currentSortValue ? 'selected' : ''} ${k == 'manual' ? 'hidden' : ''}>${sortingArr[k]}</option>`;
                  	
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
          window.sort_count++ 
		}
		return '';
      
	};
  
//     ProductSorting.prototype.bindEvents = function() {
//       // Example binding click event
//       $('.boost-pfs-filter-top-sorting select').change(function() {
//         var $this = $(this),
//             sort = $this.val();
        
//         FilterApi.setParam('sort', sort);
//         FilterApi.setParam('page', 1);
//         FilterApi.applyFilter('sort');
//       })
//     }
  
    FilterTree.prototype.afterRender = function() {
      boostPFSThemeConfig.filterOptions = [];




      this.filterOptions.forEach(function(filterOption) {
        boostPFSThemeConfig.filterOptions.push(filterOption)
      })

	//   console.log(this)


	  if(this.parent.eventType === 'init') {
	  	removeNotAvailableSizes();
	  }
    }

	//   Added by MJ: For division banner
	const division_banner = this.boostPFSThemeConfig.division_banner || null;
	const current_collection_banners = division_banner ? division_banner.banners.filter(banner => banner.collection === division_banner.handle) : 0;
	const grid_banners = this.boostPFSThemeConfig.grid_banners || null;
	const current_grid_banners = grid_banners ? grid_banners.banners.filter(banner => banner.collection === grid_banners.collection_handle) : 0;
	var newProductItemHtml = null;
	
	
	if(current_collection_banners.length > 0 || current_grid_banners.length > 0) {
		ProductList.prototype.prepareProductData = function() {
			var data = this.data;
			var current_page = Globals.queryParams.page;
			var sort_url = getParameterByName("sort");
			
			
			if(!Array.isArray(data)) {
				return [];
			}
			
			if(sort_url) return data;
			
		
			if(current_collection_banners.length > 0) {
				var filteredData;
				var productCount = data.length;
				var bannerData = []
				var categoryQuery = null;
				var noBanner = null;
				
				//Detect if filter is applied
				Object.keys(Globals.queryParams).forEach(query => {
					if(query.startsWith(Globals.prefix) && query === 'pf_t_category') {
					categoryQuery = Globals.queryParams[query]        
					}
				})
				
				
			
				current_collection_banners.forEach((banner, index) => {
					var lastIndex = current_collection_banners.length - 1;
					
					var withBanner = data.filter(product => product.tags.includes(banner.tag))
					
					
					//Insert banner data as new 0 index
					if(withBanner.length > 0) {
					withBanner.unshift(banner)
					}
					
					
					//Remove products with no banner tag on data
					for(var i =0; i< withBanner.length; i++ ) {
					for(var j= 0; j< data.length;j++) {
						if (withBanner[i].id === data[j].id) {
						data.splice(j,1);
						}
					}
					}
					
			
					bannerData = bannerData.concat(withBanner)
			
				})
				
				
				if(categoryQuery && data.length > 0) {
					bannerData.push({
					data_type: "header",
					"title": categoryQuery[0]
					})
				}
				
				if(categoryQuery) {
					filteredData = bannerData.concat(data)
				}else {
					filteredData = data.concat(bannerData)
				}

				if(current_grid_banners.length > 0) {
					current_grid_banners.forEach(banner => {
						if(banner.page === current_page) {
							filteredData.splice(banner.position, 0, banner);
						}
					})
				}
			
				var html = '';
						
			
				filteredData.forEach((product, index) => {
					html += ProductGridItem.prototype.compileTemplate(product, index, productCount)
				})
				
				
				
				newProductItemHtml = html;
			
			}else {
				if(current_grid_banners.length > 0) {
					current_grid_banners.forEach(banner => {
						if(banner.page === current_page) {
						  data.splice(banner.position, 0, banner);
						}
					})

					return data;
				}
			}
		}
	}
    
    
  //Count function including color variants: By MJ
  var all_products_with_color_count = [];
    
  // getAllProducts()
  
  
  function getAllProducts(page, currentData) {
     currentData = currentData.filter(product => !product.tags.includes('hidden-product'));
    var all_data = currentData || [],
        urlPage = page || 1,
        endpoint = `${location.origin}${location.pathname}?view=json&page=${urlPage}`;

    jQ.ajax({
      type: "GET",
      url: endpoint,
      success: function (result) {
        var data = JSON.parse(result),
            products = data.products || null,
            total = data.count;
        
        if(products) {
          products.forEach(product => {
            all_data.push(product)
          })
        }
        
        
        if(all_data.length === total) {
          seperateProductByColor(all_data)
        }else{
          getAllProducts(urlPage + 1, all_data)
        }
      },
      error: function(error) {
        console.log(error)
      }
    });
  }
  
  function seperateProductByColor(all_data) {
    var available_products = all_data.filter(product => product.available)

	// console.log(available_products)

    available_products.forEach(product => {

      var colors = product.option_with_values.find(function(item){
        var name = item.name.toLowerCase()
        if(name === 'color'){
          return item;
        }
      });
      colors.values.forEach(color => {
        var current_variant = product.variants.filter(variant => variant.available && variant.options.includes(color))

        if(current_variant.length > 0) {
          all_products_with_color_count.push(current_variant[0])
        }
      })
    })
    // renderCount()
  }
  
  function renderCount(count) {
    var current_total = count || all_products_with_color_count.length
    
    var product_item_grid = $('.product_grid_item');
    var count_text = `${product_item_grid.length} ${product_item_grid.length > 1 ? 'Items' : 'Item'}`
    var pagination_text = `Showing ${product_item_grid.length} out of ${current_total} ${current_total > 1 ? 'Products' : 'Product'}`
    
    $('.boost-pfs-filter-custom-total').text(count_text);
    $('.boost-pfs-filter-load-more-count').text(pagination_text);
    $('.boost-pfs-filter-custom-total').removeClass('total-is-loading');
  }

	// Add additional feature for product list, used commonly in customizing product list
    ProductList.prototype.afterRender = function(data, eventType) {
      if (!data) data = this.data
      if (!eventType) eventType = this.eventType


      if (boostPFSConfig.custom.enable_quickshop && data.length > 0) {
        var count = 0;
        data.forEach(function(product) {
          var url = Utils.buildProductItemUrl(product, true);
          jQ.ajax({
            type: "GET",
            url: url + '?view=boost-pfs-quickview',
            success: function (result) {
              if (jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').length == 1){
                jQ('[data-boost-pfs-quickshop-id="'+ product.id + '"]').replaceWith(result);
              }
              count++;
              if (count == data.length){
                buildTheme();
              }
            }
          });
        })
      } else {
        buildTheme();
      }

	//   Render the products if has division banner
	  if(newProductItemHtml) {
        $('.boost-pfs-filter-products').empty();
        $('.boost-pfs-filter-products').append(newProductItemHtml);
        newProductItemHtml = null;
      }


      
      if(eventType === 'init') {
        // renderCount()
        initDynamicONCollectionMenu();
        initQuickAddonCollection()
      }else {

        var filter_product_count = data.reduce((a,b) => {
            var color_opt = b.options_with_values.find(opt => opt.name === 'color')
            let color_count;
            if(color_opt) {
                color_count = color_opt.values.length
            }
            if(color_count) {
                return a + color_count
            }
        }, 0);

        // renderCount(filter_product_count)
        scrollToGrid();
      }
      // Create a blank array for product impressions
	  if(typeof(track_product_impression) === 'function' && (eventType === 'init' || eventType === 'sort')) {
	  	track_product_impression(data)
	  }
    };

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {

		setTimeout(function (){
			let filterToggle = document.querySelectorAll('.boost-pfs-filter-button[aria-expanded="false"]');

			filterToggle.forEach(function (element, index){

				element.addEventListener('click', function (e){
					$('.boost-pfs-filter-option').removeClass('boost-pfs-filter-option-collapsed');
					$('.boost-pfs-filter-option .boost-pfs-filter-option-content').hide();

					if(e.target.closest('.boost-pfs-filter-option').classList.contains('boost-pfs-filter-option-collapsed')){
						return;
					} else {
						let parent = e.target.closest('.boost-pfs-filter-option')
						parent.classList.add('boost-pfs-filter-option-collapsed');
						$(parent).find('.boost-pfs-filter-option-content').show();
					}
				})
			})
		}, 10)
	};
  
  var educ_banner_slider = $('.educ_banner_slider')

  if(educ_banner_slider.children().length > 5) {
    educ_banner_slider.flickity({
      // options
      cellAlign: 'left',
      contain: true,
      pageDots: false
    })
  }

	function buildTheme(){
		if (window.SPR && typeof SPR.initDomEls == 'function' && typeof SPR.loadBadges == 'function') {
			SPR.initDomEls();
			SPR.loadBadges();
		}

		if(typeof Shopify.PaymentButton != 'undefined' && typeof Shopify.PaymentButton.init == 'function'){
			Shopify.PaymentButton.init();
		}

		if (boostPFSConfig.custom.hasOwnProperty('show_multiple_currencies') &&
		boostPFSConfig.custom.show_multiple_currencies == true &&
		typeof convertCurrencies == 'function') {
			convertCurrencies();
		}
	}
  //   for educ banners by: MJ

  $('.educt-btn').click(function() {
    var $this = $(this),
        size = $this.data('value'),
        educBanners = $this.parent().parent().find(`.educ_banners[data-value="${size}"]`);


    $this.addClass('btn-active').siblings().removeClass('btn-active');
    educBanners.show().siblings().hide();
  })

  $('.eb-gg-tab').click(function() {
	var $this = $(this),
		tab_index = $this.attr('tabindex');

	$this.addClass('tab--active').siblings().removeClass('tab--active');
	$(`.eb-gg-tabpanel .eb-gg-grouppanel[tabindex="${tab_index}"]`).addClass('panel--active').siblings().removeClass('panel--active');
  })


  $('.educ_banners .banner, [data-educ-filter-btn]').click(function(e) {
    e.preventDefault();
    var $this = $(this),
        size = $this.data('value') || null,
        price = parseInt($this.data('price')) || null,
        category = $this.data('category'),
		department = $this.data('department') || null;
    
    var currentParams = [];
	var optionsWithValues = []

    Object.keys(Globals.queryParams).forEach(param => {
      if(param.startsWith(Globals.prefix)) {
        currentParams.push(param)
      }
    })
    
    if(currentParams.length > 0) {
      currentParams.forEach(param => {
        window.FilterApi.setParam(param, null)
      })
      window.FilterApi.setParam("page", 1)
      window.FilterApi.applyFilter("clearAll", {})
    }

    if(size) {
		optionsWithValues.push(
			{
			  filterOptionId: 'pf_t_category',
			  filterOptionValue: category.toString().split(',').length > 1 ? category.toString().split(',').map(str => str.trim()) : category
			},
			{
			  filterOptionId: 'pf_opt_size',
			  filterOptionValue: size.toString().split(',').map(str => str.trim())
			}
		)
    }else if(price && typeof price === 'number') {
		optionsWithValues.push(
			{
				filterOptionId: 'pf_t_category',
				filterOptionValue: category.toString().split(',').length > 1 ? category.toString().split(',').map(str => str.trim()) : category
			},
			{
				filterOptionId: 'pf_p_price',
				filterOptionValue: `${parseInt(product_min_price)}:${price}`
			}
		)
    }else {
		if(category) {
			optionsWithValues.push(
				{
					filterOptionId: 'pf_t_category',
					filterOptionValue: category.toString().split(',').length > 1 ? category.toString().split(',').map(str => str.trim()) : category
				}
			)
		}
    }
	if(department) {
		optionsWithValues.push({
			filterOptionId: 'pf_t_department',
			filterOptionValue: department.toString().split(',').length > 1 ? department.toString().split(',').map(str => str.trim()) : department
		})
	}
    setTimeout(function() {
      applyFilter(optionsWithValues)
    }, 500)
  })


  function removeNotAvailableSizes() {
		// remove shop by size values if not available
		if($('.shop-by-size').length > 0) {
			var sizeFilterValue = [];
			var categoryFilterValue = [];
			var sizeFilter = boostPFSThemeConfig.filterOptions.find(size => size.filterOptionId === 'pf_opt_size');
			var categoryFilter = boostPFSThemeConfig.filterOptions.find(size => size.filterOptionId === "pf_t_category");
			var sizeEls = $('.sbs-option-value');
			
			sizeFilter.filterItems.forEach(size => {
				sizeFilterValue.push(size.value)
			})
			categoryFilter.filterItems.forEach(cat => {
				categoryFilterValue.push(cat.value)
			})

			sizeEls.each((i, el) => {
				var $el = $(el),
					$category = $el.data('sbs-category'),
					$values = $el.data('values').toString().split(','),
					isAvailable = $values.some(value => sizeFilterValue.includes((value).trim()));

				if(!isAvailable) {
					$el.hide();
				}else {
					$el.show();
				}


				if($category === 'Shoes') {
					if(!categoryFilterValue.includes($category)) {
						$el.closest('.sbs-option-container').hide()
					}else {
						$el.closest('.sbs-option-container').show()
					}
				}
			})

		}
	}
  
  //Check URL parameter by name
  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function scrollToGrid() {
    $('html, body').animate({
      scrollTop: $(".boost-pfs-filter-products").offset().top
    }, 500);
  }

  //Check if string is number
  function isNumeric(str) {
    if (typeof str != "string") return false
    return !isNaN(str) &&
      !isNaN(parseFloat(str))
  }
  //Collection sidemenu by: MJ
	function initDynamicONCollectionMenu() {
		if(boostPFSThemeConfig.custom.show_dynamic_sidebar_menu) {
			var menu_data = $('.collection__sidebar_data'),
				active_menu = null,
				sidebar_menu_container = $('.boost-pfs-filter-custom-dynamic-sidebar-menu'),
				custom_menu_filter = boostPFSThemeConfig.custom_menu_filter,
				menuQueryParam = getParameterByName("category_side_menu");


			//Get the current active menu
			if(custom_menu_filter) {
				active_menu = custom_menu_filter;
			}else {
				menu_data.each((i, el) => {
				var data = JSON.parse($(el).text())

				var active = data.filter(menu => menu.active || menu.child_active)

				if(active.length > 0 && active_menu !== data) {
					active_menu = data;
				}
				})
			}

			//Build sidebar menu if there is an active menu
			if(active_menu) {
				renderONDynamicMenu(active_menu)
			}

			function renderONDynamicMenu(active_menu) {
                if(!document.querySelector('.boost-pfs-filter-dynamic-sidebar-menu-inner')) {
                  sidebar_menu_container.append(buildDynamicSidebarMenu(active_menu))
                }
				var totalHeight = 0;
				$('.boost-pfs-filter-dynamic-sidebar-menu-inner').find('.dynamic-menu-items').each((index, list) => {
					totalHeight += list.offsetHeight
				})
				if(totalHeight < 291) {
					$('.boost-pfs-filter-custom-dynamic-sidebar-menu').find('.toggle-menu-height').remove();
				}
			}

			function buildDynamicSidebarMenu(data) {
				var html = boostPFSThemeConfig.templates.dynamic_sidebar_menu;
				html = html.replace(/{{menus}}/g, buildDynamicMenu(data));
				return html;
			}

			function buildDynamicMenu(data) {
				var categoryContainer = '';

				data.forEach(menu => {
					categoryContainer += `<ul class="dynamic-menu-items" data-column="${menu.title}">{{menuListItems}}</ul>`
					if(menu.links?.length > 0) {
						var categoryLists = ''
						menu.links.forEach(category => {
							var categoryListItem = ''
							if(category.links) {
								categoryLists += `<li class="dynamic-menu-item" data-category="${category.title}"><h2 class="dynamic-menu-category-title">${category.title}</h2><ul class="dynamic-menu-list">{{menuItems}}</ul></li>`

								if(category.links.length > 0) {
									category.links.forEach(item => {
										var active = item.active && item.current ? 'active' : '';
										categoryListItem += `<li class="dynamic-menu-item"><a href="${item.url}" class="${active}">${item.title}</a></li>`
									})
									categoryLists = categoryLists.replace(/{{menuItems}}/g, categoryListItem);
								}
							}
						})
						categoryContainer = categoryContainer.replace(/{{menuListItems}}/g, categoryLists);
					}
				})
				return categoryContainer;
			}

			//     Toggle menu height on button click
			$('.toggle-menu-height').click(function() {
				var btn = $(this),
					menuContainer = $('.boost-pfs-filter-dynamic-sidebar-menu-inner'),
					label = btn.find('.btn-label');
				
				//Animate button arrow
				btn.attr('data-expanded', btn.attr('data-expanded') === 'false' ? 'true' : 'false')
				//Toggle button text
				label.text(btn.attr('data-expanded') !== 'false' ? 'Show Less' : 'Show All');
				//Toggle height of menu container by class
				setTimeout(function() {
                  btn.attr('data-expanded') !== 'false' ? menuContainer.addClass('is-expanded') : menuContainer.removeClass('is-expanded');
				}, 300)
				
			})
		}
	}
	function initQuickAddonCollection() {
		$(document).on('click', '.js-select-value:not(.disabled)', function() {
		var $btn = $(this),
			options = $('[pfs-custom-variant-selection]'),
			data = JSON.parse($btn.closest('.product-wrap').find(".variantData").text().trim())
			add_btn = $btn.closest('.pr-option-inner').find('.quick-add-cta-btn'),
			id_input = $btn.closest('.pr-option-inner').find('#pfs-selected-variant-id');

		$btn.toggleClass('selected').siblings().removeClass('selected');

		validateSelection(options.find('.option-value.selected'), options, data);
		$('.quick-add-warning').remove();
		add_btn.removeClass('item-added').find('.added-to-cart-check-icon').remove();

		if(options.find('.option-value.selected').length === options.length) {
			var current_variant = getSelectedVariant(options, data)
			add_btn.addClass('btn-ready');
			add_btn.find('.btn-label').text('Add to bag');
			if(current_variant) {
				id_input.val(current_variant.id).change();
			}
		}else {
			add_btn.removeClass('btn-ready');
			add_btn.find('.btn-label').text('Select a size');
		}
		})

		$(document).on('click', '.quick-add-cta-btn', function() {
		var $this = $(this),
			options = $('[pfs-custom-variant-selection]');

		var errorTpl = `<div class="quick-add-warning">Please select a <strong>{{options}}</strong> before adding to bag.</div>`;

		if($this.hasClass('btn-ready')) {
			const form = $(this).closest('form');
			quickAdd(form);
		}else if($this.hasClass('item-added')) {
			$this.closest('.product-wrap').find('.quick-add-btn').show();
			$this.closest('.pr-option-container').remove();
		}else{
			var blank_options = [];
			options.each((i, option) => {
			var $option = $(option),
				selectedValueEl = $option.find('.option-value.selected'),
				optionName = $option.data('option');
			if(selectedValueEl.length === 0) {
				blank_options.push(optionName);
			}
			})

			if(blank_options.length > 0) {
			errorTpl = errorTpl.replace(/{{options}}/g, blank_options.join(', '));
			$this.closest('form').find('.quick-add-warning').remove();
			$this.closest('form').find('.pr-options').append(errorTpl);
			}
		}
		})

		$(document).on('click', '.js-quick-add-on', function() {
		var $btn = $(this),
			data = JSON.parse($btn.find(".variantData").text().trim()),
			container = $btn.parent().find('.product__imageContainer');

		var optionTpl = buildDynamicSelection(data);

		if(container.find('.pr-option-container')) {
			container.find('.pr-option-container').remove();
			container.append(optionTpl);
		}else {
			container.append(optionTpl);
		}
		$btn.toggle();
		})

		boostPFSThemeConfig.initQuickAdd = function() {
		var $btn = $(this),
			data = JSON.parse($btn.find(".variantData").text().trim()),
			container = $btn.parent().find('.product__imageContainer');

		var optionTpl = buildDynamicSelection(data);

		if(container.find('.pr-option-container')) {
			container.find('.pr-option-container').remove();
			container.append(optionTpl);
		}else {
			container.append(optionTpl);
		}
		$btn.toggle();
		}

		$(document).mouseup(function(e) 
							{
		if($(window).width > 1023) {
			var container = $(".pr-option-container");
		}else {
			var parentContainer = $(".pr-option-container");
			var container = $(".pr-option-container .pr-option-inner");
		}
		var bg = $('.pr-option-bg')

		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0) 
		{
			parentContainer.length > 0 ? parentContainer.remove() : container.remove();
			$('.js-quick-add-on').show();
		}
		});

		$(document).on('click', '.js-close-option-popup', function() {
		var $btn = $(this),
			panel = $btn.closest('.pr-option-container'),
			quick_add_btn = $btn.closest('.product-wrap').find('.js-quick-add-on');

		panel.remove();
		quick_add_btn.show();
		})

		function buildDynamicSelection(data) {
		var optionTpl = boostPFSThemeConfig.templates.quick_add_options_tpl;

		optionTpl = optionTpl.replace(/{{id}}/g, data.id);

		var optionEls = '';
		data.options.forEach((option, i) => {
			var values = [];
			optionEls += `<div class="option ${option.name}" data-option="${option.label}" data-index="${i}" pfs-custom-variant-selection><div class="pr-option-name">${option.label}:</div><ul class="option-values">{{optionValues}}</ul></div>`
			var optionValues = '';
			option.values.forEach(value => {
			var by_color_variants = data.variants.filter(variant => {
				var title_found = variant.title.split(' / ')[data.current_color.index] === data.current_color.value;
				return title_found;
			});

			var filtered_variants = option.name !== 'color' ? by_color_variants : data.variants;


			var highlighted_variants = filtered_variants.filter(variant => {
				var title_found = variant.title.split(' / ')[i] === value.title;
				return title_found && variant.available
			})


			if(!values.includes(value.title)) {
				var isColor = option.name === 'color';
				var colorImage = isColor ? boostPFSAppConfig.general.file_url.split('?')[0] + `${data.product_handle}-` + `${Utils.slugify(value.title)}-swatch` + '_50x.png' : null;
				var colorImageBackup = isColor ? boostPFSAppConfig.general.file_url.split('?')[0] + `${data.product_handle}-` + `${value.title.trim().split(' ').join('-')}-swatch` + '_50x.png' : null;
				var isColorActive = isColor ? data.current_color.value === value.title ? true : false : false;
				optionValues += `<li class="option-value js-select-value${highlighted_variants.length <= 0 ? ' disabled' : ''}${isColorActive ? ' selected' : ''}"><div class="value-label">${colorImage ? `<img class="pr-swatch-img" style="background-color: ${value.title}" src="${colorImage}" onerror="this.onerror=null;this.src='${colorImageBackup}';" />` : ''}${value.title}</div><input type="hidden" class="option-input-value" value="${value.title}"></li>`;
				values.push(value.title);
			}
			})
			optionEls = optionEls.replace(/{{optionValues}}/g, optionValues);
		})
		optionTpl = optionTpl.replace(/{{options}}/g, optionEls);

		return optionTpl;
		}

		function getSelectedVariant(optionEl, data) {
		var selected_values = [];

		// selected_values.push(data.current_color);

		optionEl.each((i,option) => {
			var $option = $(option),
				selected_value = $option.find('.option-values .option-value.selected .option-input-value').val();

			if(selected_value.length > 0) {
			selected_values.push({
				index: parseInt($option.data('index')),
				option: $option.data('option'),
				value: selected_value
			})
			}
		})

		var selected_variant = data.variants.find(function(variant) {
			return selected_values.every(function(values) {
			var title_found = variant.title.split(' / ')[values.index] === values.value;
			return title_found;
			})
		})

		return selected_variant;
		}

		function validateSelection(currentOptions, optionEls, data) {
		var selected_values = [];

		currentOptions.each((i, option) => {
			var $option = $(option);
			selected_values.push({
			index: parseInt($option.closest('[pfs-custom-variant-selection]').data('index')),
			option: $option.closest('[pfs-custom-variant-selection]').data('option'),
			value: $option.find('.option-input-value').val()
			})
		})
		// selected_values.push(data.current_color);

		var highlighted_variants = data.variants.filter(function(variant) {
			return selected_values.every(function(values) {
			var title_found = variant.title.split(' / ')[values.index] === values.value;
			return title_found;
			})
		})

		optionEls.each((i, option) => {
			var $option = $(option),
				$index = parseInt($option.data('index')),
				hasSelected = selected_values.find(value => value.index === $index) || null;

			if(!hasSelected) {
			$option.find('.option-values .option-value').each((index, option_value) => {
				var $option_value = $(option_value),
					$value = $option_value.find('.option-input-value').val(),
					target_value = highlighted_variants.find(variant => {
					var title_found = variant.title.split(' / ')[$index] === $value;
					return title_found && variant.available
					}),
					is_available = target_value ? true : false;
				if(is_available) {
				$option_value.removeClass('disabled')
				}else{
				$option_value.addClass('disabled')
				}
			})
			}
		})
		}

		function quickAdd(form) {
			const $addToCartBtn = form.find('.button--add-to-cart');
			var loader = boostPFSThemeConfig.templates.loader_tpl;
			$.ajax({
				url: '/cart/add.js',
				dataType: 'json',
				cache: false,
				type: 'post',
				data: form.serialize(),
				beforeSend: function () {
                    var product = JSON.parse(form.closest('.product-image__wrapper').find('.js-quick-add-on .variantData').text()).product;
                    var solidFF = window.solidFF || {};
                    if(product.tags.includes('FF150')) {
                      var selected_quantity = parseInt(form.find('[name="quantity"]').val());
                      var same_product = solidFF.cart_items.filter(item => item.product.tags.includes('FF150'));
                      var cart_quantity = 0;
                      var substract_quantity = 10 - selected_quantity;
                      same_product.forEach(item => {
                        cart_quantity += item.quantity;
                      })
                      if(cart_quantity >= 10){
                        alert('You have exceeded the maximum order of 10 Flip Flops per user.');
                        xhr.abort();
                        return;
                      }
                    }
					$addToCartBtn.addClass('init-adding-to-cart').removeClass('btn-ready').find('.btn-label').empty().append(loader)
				},
				success: function (product) {
                var solidFF = window.solidFF || {};
                var main_product = JSON.parse(form.closest('.product-image__wrapper').find('.js-quick-add-on .variantData').text()).product;
            
                var new_added_product = {
                  item: product,
                  quantity: product.quantity,
                  product: main_product
                }
                
                solidFF.cart_items.push(new_added_product);
                  
				var check_icon = boostPFSThemeConfig.templates.check_icon_tpl;


				$addToCartBtn
				.append(check_icon)
				.addClass('item-added')
				.removeClass('init-adding-to-cart')
				.find('.loading-dots')
				.remove();

				$addToCartBtn.find('.btn-label').text('Added to bag');

				Shopify.theme.jsAjaxCart.showDrawer();
				Shopify.theme.jsAjaxCart.updateView();
                  console.log(product)
                gtag("event", "add_to_cart", {
                  currency: "PHP",
                  items: [
                    {
                      item_id: product.product_id.toString(),
                      item_name: product.product_title,
                      currency: "PHP",
                      item_brand: product.vendor,
                      item_category: product.product_type,
                      item_variant: product.variant_title,
                      price: (product.price * 0.01).toFixed(2),
                      quantity: product.quantity
                    }
                  ]
                });
                  
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                  'event': 'addToCart',
                  'ecommerce': {
                    'currencyCode': 'PHP',
                    'add': {
                      'products': [
                        {
                        'name': product.product_title,
                        'id': product.product_id.toString(),
                        'price': (product.price * 0.01).toString(),
                        'brand': product.vendor,
                        'category': product.product_type,
                        'variant': product.variant_title,
                        'quantity': product.quantity
                       }
                      ]
                    }
                  }
                });

// 				gtag('event', 'conversion', {
// 					'send_to': 'AW-787432234/B6M-CI-BsvQCEKqGvfcC',
// 					'value': product.price,
// 					'currency': 'PHP'
// 				});

                  

				},
				error: function (XMLHttpRequest) {
				let response = eval('(' + XMLHttpRequest.responseText + ')');
				response = response.description;
				alert(response.replace('All 1 ', 'All '))
				}
			});
		}
	}
	// shop by size by: MJ
	$('.js-sbs').click(function() {
		var $btn = $(this),
			size_values = $btn.parent().data('values').toString().split(','),
			category_value = $btn.parent().data('sbs-category');

		/* Clear all previous filter first */
		var currentParams = [];

		Object.keys(Globals.queryParams).forEach(param => {
			if(param.startsWith(Globals.prefix)) {
				currentParams.push(param)
			}
		})

		if(currentParams.length > 0) {
			currentParams.forEach(param => {
				window.FilterApi.setParam(param, null)
			})
			window.FilterApi.setParam("page", 1)
			window.FilterApi.applyFilter("clearAll", {})
		}
		/* Clear all previous filter first */
		var selected_values = [
			{
				filterOptionId: "pf_opt_size",
				filterOptionValue: size_values
			}
		];

		if(category_value !== 'Apparel') {
			selected_values.push({
				filterOptionId: "pf_t_category",
				filterOptionValue: category_value
			})
		}
		// console.log(Globals)
		setTimeout(() => {
			applyFilter(selected_values)
		}, 1000)
	})
	function applyFilter(optionsWithValues) {
		var api = window.FilterApi;
		boostPFSThemeConfig.filterOptions.forEach(function(filterOption) {
		var selectedOption = optionsWithValues.find(option => option.filterOptionId === filterOption.filterOptionId) || null;
		var values = [],
			id = filterOption.filterOptionId;


			if(selectedOption) {
				console.log(selectedOption)
				filterOption.filterItems.forEach(item => {
					if(item.key === "pf_p_price") {
						values.push(selectedOption.filterOptionValue)
					}else {
						if(selectedOption.filterOptionValue === item.value || Array.isArray(selectedOption.filterOptionValue) ? selectedOption.filterOptionValue.includes(item.value) : false) {
							values.push(item.value)
						}
					}
				})
				console.log(values)
              // Exclude hidden-product tag from filter results
				if (id === 'pf_t_tags') {
					values = values.filter(value => value !== 'hidden-product');
				}
              
				api.setParam(id, values)
				api.setParam(id + "_and_condition", !!(filterOption.useAndCondition && values.length > 0) || null)
				api.setParam(id + "_show_exact_rating", !!(filterOption.showExactRating && values.length > 0) || null)
				api.setParam(id + "_exclude_from_value", !!(filterOption.excludePriceFromValue && values.length > 0) || null)
			}
		})
		
		var currentParams = [];

		Object.keys(Globals.queryParams).forEach(param => {
			if(param.startsWith(Globals.prefix)) {
				currentParams.push(param)
			}
		})
		if(currentParams.length > 0) {
			api.setParam("page", 1)
			api.applyFilter('filter')
		}
	}
})();